import { render, staticRenderFns } from "./ExtraOptionText.vue?vue&type=template&id=374da26a&scoped=true&"
import script from "./ExtraOptionText.vue?vue&type=script&lang=js&"
export * from "./ExtraOptionText.vue?vue&type=script&lang=js&"
import style0 from "./ExtraOptionText.vue?vue&type=style&index=0&id=374da26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374da26a",
  null
  
)

export default component.exports